// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2njjd","right":"styles_right__nDLf6"};